import {Reducer} from 'redux';
import {
  SHOW_SUBSCRIPTION_OVERLAY,
  HIDE_SUBSCRIPTION_OVERLAY,
  SUBSCRIBE,
  UPDATE_SUBSCRIPTION,
} from './reducers-const';

export interface Subscriptions {
  overlay: boolean;
  subscribed: boolean | null;
}

const defaultValues: Subscriptions = {
  overlay: false,
  subscribed: null,
};

const subscriptions: Reducer<Subscriptions> = (state: Subscriptions = defaultValues, action) => {
  switch (action.type) {
    case SHOW_SUBSCRIPTION_OVERLAY:
      return {
        ...state,
        overlay: true,
      };
    case HIDE_SUBSCRIPTION_OVERLAY:
      return {
        ...state,
        overlay: false,
      };
    case SUBSCRIBE:
      return {
        ...state,
        subscribed: action.subscribed,
      };
    case UPDATE_SUBSCRIPTION:
      return {
        ...state,
        subscribed: action.subscibed,
      };
    default:
      return state;
  }
};

export default subscriptions;
